import { isAxiosError } from 'axios';

/**
 * Extract a human-readable error message from an unknown error.
 * Handles Axios errors (extracts response.data.detail) and generic Error objects.
 */
export function getErrorMessage(error: unknown): string {
  if (isAxiosError(error)) {
    const detail = error.response?.data?.detail;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) return detail.map((d) => d.msg).join(', ');
  }
  return error instanceof Error ? error.message : 'Unknown error';
}
